<h4 class="f-w-700">{{ title }}</h4>
<nav>
  <ol class="breadcrumb justify-content-sm-start align-items-center mb-0">
    <li class="breadcrumb-item">
      <a [routerLink]="['/dashboard/default']">
        <app-feather-icons [icons]="'home'"></app-feather-icons>
      </a>
    </li>
    @if (breadcrumbs && breadcrumbs.parentBreadcrumb) {
      <li class="breadcrumb-item f-w-400">{{ breadcrumbs.parentBreadcrumb }}</li>
    }
    @if (breadcrumbs && breadcrumbs.childBreadcrumb) {
      <li class="breadcrumb-item f-w-400 active">{{ breadcrumbs.childBreadcrumb }}</li>
    }
  </ol>
</nav>
